import {
  canShowFinancialAnalysis,
  canShowMap,
  canShowPartners,
  canShowSchedule,
} from '@/helpers/organizationFeatureVisibility'

const userHasRolesToSchedule = (me, config) => {
  const myRawRoles = Array.isArray(me?.rawRoles) ? me.rawRoles : []
  const rolesForScheduling = [
    ...(config?.schedule?.userRolesForScheduling || []),
    ...['ROLE_DRIVER', 'ROLE_PARAMEDIC'],
  ]

  return rolesForScheduling.some(role => myRawRoles.includes(role))
}

const userIsHrManager = me => {
  const myRoles = Array.isArray(me?.roles) ? me.roles : []

  return myRoles.includes('ROLE_HR_MANAGER')
}

const userHasRolesToScheduleOrIsHrManager = (me, config) => userHasRolesToSchedule(me, config) || userIsHrManager(me)

export default [
  {
    route: 'dashboard',
    title: 'dashboard.title',
    icon: 'BarChart2Icon',
    roles: ['ROLE_USER'],
  },
  {
    route: 'dashboard-finance',
    title: 'dashboard.finance.title',
    icon: 'DollarSignIcon',
    // tag: 'shared.new',
    // tagVariant: 'light-success',
    roles: ['ROLE_FINANCE_MANAGER'],
    featureVisibilityMethod: canShowFinancialAnalysis,
  },
  {
    route: 'dashboard-map',
    title: 'dashboard.map.title',
    icon: 'MapIcon',
    // tag: 'shared.new',
    // tagVariant: 'light-success',
    roles: ['ROLE_DISPATCHER'],
    featureVisibilityMethod: canShowMap,
  },
  {
    route: 'report',
    title: 'report.title',
    icon: 'FileTextIcon',
    // tag: 'shared.new',
    tagVariant: 'light-success',
    roles: ['ROLE_DATA_ANALYST', 'ROLE_HR_MANAGER', 'ROLE_ADVANCED_DISPATCHER'],
  },
  {
    header: 'partner.menu.header',
    roles: ['ROLE_EXTERNAL_REQUESTER'],
    featureVisibilityMethod: canShowPartners,
  },
  {
    route: 'partner-order-request-list',
    title: 'partner.order-request.list.title',
    icon: 'ClipboardIcon',
    roles: ['ROLE_EXTERNAL_REQUESTER'],
    featureVisibilityMethod: canShowPartners,
  },
  {
    title: 'schedule.title',
    icon: 'CalendarIcon',
    roles: ['ROLE_USER', 'ROLE_HR_MANAGER'],
    conditionalShowMethod: userHasRolesToScheduleOrIsHrManager,
    featureVisibilityMethod: canShowSchedule,
    children: [
      {
        route: 'schedule-my-availability',
        title: 'schedule.my-availability.title',
        conditionalShowMethod: userHasRolesToSchedule,
        roles: ['ROLE_USER'],
      },
      {
        route: 'schedule-planner',
        title: 'schedule.planner.title',
        roles: ['ROLE_HR_MANAGER'],
        conditionalShowMethod: userIsHrManager,
      },
    ],
  },
  {
    header: 'order.orders_title',
    roles: ['ROLE_DISPATCHER', 'ROLE_TEAM_LEADER'],
  },
  {
    route: 'order-list',
    title: 'order.list.title',
    icon: 'BookOpenIcon',
    roles: ['ROLE_DISPATCHER', 'ROLE_TEAM_LEADER'],
  },
  {
    route: 'order-planner',
    title: 'order.planner.title',
    icon: 'CalendarIcon',
    roles: ['ROLE_DISPATCHER'],
  },
  {
    route: 'dispatcher-order-request-review-list',
    title: 'dispatcher.order-request.review.list.title',
    icon: 'ClipboardIcon',
    roles: ['ROLE_DISPATCHER'],
    featureVisibilityMethod: canShowPartners,
  },
  {
    route: 'address-list',
    title: 'address.menu.title',
    // tag: 'shared.new',
    tagVariant: 'light-success',
    icon: 'MapPinIcon',
    roles: ['ROLE_DISPATCHER'],
  },
  {
    route: 'customer-list',
    title: 'customer.menu.title',
    // tag: 'shared.new',
    tagVariant: 'light-success',
    icon: 'BookmarkIcon',
    roles: ['ROLE_FINANCE_MANAGER'],
  },
  {
    header: 'staff.staff_title',
    roles: ['ROLE_HR_MANAGER', 'ROLE_USER_MANAGEMENT', 'ROLE_DISPATCHER', 'ROLE_TEAM_LEADER'],
  },
  {
    route: 'team-list',
    title: 'team.list.title',
    // tag: 'shared.new',
    tagVariant: 'light-success',
    icon: 'UsersIcon',
    roles: ['ROLE_DISPATCHER', 'ROLE_TEAM_LEADER'],
  },
  {
    route: 'user-list',
    title: 'conf.user.title',
    icon: 'UserIcon',
    roles: ['ROLE_USER_MANAGEMENT'],
  },
  {
    header: 'conf.title',
    roles: ['ROLE_ADMIN', 'ROLE_DISPATCHER'],
  },
  {
    route: 'vehicle-list',
    title: 'conf.vehicle.title',
    icon: 'TruckIcon',
    roles: ['ROLE_DISPATCHER', 'ROLE_CONFIG_MANAGEMENT'],
  },
  {
    route: 'external-partner-list',
    title: 'partner-admin.menu.title',
    icon: 'BriefcaseIcon',
    roles: ['ROLE_ADMIN'],
    featureVisibilityMethod: canShowPartners,
  },
  {
    title: 'conf.settings.title',
    icon: 'SettingsIcon',
    roles: ['ROLE_CONFIG_MANAGEMENT'],
    children: [
      {
        route: 'settings-team-definition-list',
        title: 'conf.settings.team-definitions.title',
        roles: ['ROLE_CONFIG_MANAGEMENT'],
      },
      {
        route: 'settings-checklist-dictionary-list',
        title: 'conf.settings.checklist-dictionary.title',
        roles: ['ROLE_CONFIG_MANAGEMENT'],
      },
    ],
  },
]
